import { Input, Select } from "antd";
import { ColumnsType } from "antd/es/table";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import CustomTable from "../../../components/ui/CustomTable";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";

export default function TransactionHistory() {
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
    },
    {
      title: "Pay to",
      dataIndex: "payTo",
    },
    {
      title: "Amount (BDT)",
      align: "center",
      dataIndex: "amount",
    },
    {
      title: "Date",
      align: "center",
      dataIndex: "date",
    },
  ];

  return (
    <>
      <SidebarLayout title="Transaction History">
        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={100}
          dataSource={addKeyInArray(data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input suffix={<SearchIcon />} placeholder="Search by Name, Id" />

              <Select
                // defaultValue="lucy"
                className="w-[100px]"
                allowClear
                suffixIcon={<SelectDownIcon />}
                options={[
                  { value: "all", label: "All" },
                  { value: "Inactive", label: "Inactive" },
                  { value: "Review", label: "Review" },
                  { value: "Trial", label: "Trial" },
                ]}
                placeholder="All"
              />
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

interface LeaveDataType {
  key: string;
  transactionId: string;
  payTo: string;
  amount: number;
  date: string;
}

const data: LeaveDataType[] = [
  {
    key: "1",
    transactionId: "XYZ2541",
    payTo: "Sheba Business | +08123456789",
    amount: 100,
    date: "8 Jan, 2024",
  },
  {
    key: "2",
    transactionId: "XYZ2541",
    payTo: "Sheba Business | +08123456789",
    amount: 100,
    date: "8 Jan, 2024",
  },
  {
    key: "3",
    transactionId: "XYZ2541",
    payTo: "Sheba Business | +08123456789",
    amount: 100,
    date: "8 Jan, 2024",
  },

  {
    key: "4",
    transactionId: "XYZ2541",
    payTo: "Sheba Business | +08123456789",
    amount: 100,
    date: "8 Jan, 2024",
  },
];
